import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { routes } from '@model/constants/routes';
@Injectable({
  providedIn: 'root',
})
export class InternalBuroService {
  apiUrl = environment.apiUrl;
  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  startWorkflow(): Observable<any> {
    const data = {
      id: 2,
      name: 'RAPIPLAZO',
      active: true,
    };

    return this.http.post<any>(this.apiUrl + routes.internalBuroStartWorkFlow, data, { headers: this.headers });
  }
}
